"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseMask;
var _constants = require("../constants");
function parseMask(_ref) {
  let {
    formatChars,
    mask,
    maskPlaceholder
  } = _ref;
  const permanents = [];
  const combinedFormatChars = {
    ..._constants.defaultFormatChars,
    ...formatChars
  };
  if (!mask) {
    return {
      maskPlaceholder: '',
      mask: '',
      prefix: '',
      lastEditablePosition: 0,
      permanents: []
    };
  }
  if (typeof mask === 'string') {
    let isPermanent = false;
    let parsedMaskString = '';
    mask.split('').forEach(character => {
      if (!isPermanent && character === '\\') {
        isPermanent = true;
      } else {
        if (isPermanent || !combinedFormatChars[character] && !combinedFormatChars[character.toLowerCase()]) {
          permanents.push(parsedMaskString.length);
        }
        parsedMaskString += character;
        isPermanent = false;
      }
    });
    mask = parsedMaskString.split('').map((character, index) => {
      if (permanents.indexOf(index) === -1) {
        return combinedFormatChars[character];
      }
      return character;
    });
  } else {
    mask.forEach((character, index) => {
      if (typeof character === 'string') {
        permanents.push(index);
      }
    });
  }
  if (maskPlaceholder) {
    let maskPlaceholderBuilder;
    if (maskPlaceholder.length === 1) {
      maskPlaceholderBuilder = mask.map((character, index) => {
        if (permanents.indexOf(index) !== -1) {
          return character;
        }
        return maskPlaceholder;
      });
    } else {
      maskPlaceholderBuilder = maskPlaceholder.split('');
    }
    if (mask && maskPlaceholderBuilder) {
      permanents.forEach(position => {
        if (mask[position]) {
          maskPlaceholderBuilder[position] = mask[position];
        }
      });
      maskPlaceholder = maskPlaceholderBuilder.join('');
    }
  }
  const prefix = permanents.filter((position, index) => position === index).map(position => mask && mask[position] ? mask[position] : '').join('');
  let lastEditablePosition = mask.length - 1;
  while (permanents.indexOf(lastEditablePosition) !== -1) {
    lastEditablePosition--;
  }
  return {
    maskPlaceholder,
    prefix,
    mask,
    lastEditablePosition,
    permanents
  };
}